export const navigateArticle = articleId => {
  if (!window.Lighthouse) {
    // eslint-disable-next-line no-console
    console.log('Lighthouse is not loaded.');
    return;
  }

  const closeOnClickAwayElements = document.querySelectorAll(
    '[id=root], [id=wrappedModal], [role=tooltip]'
  );

  const hideLighthouse = () => {
    window.Lighthouse.hide();
    closeOnClickAwayElements.forEach(elem => {
      elem.removeEventListener('mousedown', hideLighthouse);
    });
  };

  document.getElementById('lighthouse').style.display = 'block';
  window.Lighthouse.navigate('article', articleId);

  closeOnClickAwayElements.forEach(elem => {
    elem.addEventListener('mousedown', hideLighthouse);
  });

  window.addEventListener(
    'keyup',
    e => {
      if (e.key === 'Escape') {
        window.Lighthouse.hide();
      }
    },
    { once: true }
  );
};
